module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../images/arrow-right.59e553bf.svg";